import React, { FormEvent } from 'react';

import DatePickerBase from './Base';

import { CoreFormElementTime, CoreFormInputProps } from '../../forms/';
import { IsFunction } from '../../../../utils/';

/**
 * End Time Component
 * @export
 * @class EndTimeComponent
 * @extends {DatePickerBase<CoreFormInputProps>}
 */
export default class EndTimeComponent extends DatePickerBase<CoreFormInputProps> {
  /**
   * Display Name
   * @static
   * @type {string}
   * @memberof EndTimeComponent
   */
  public static displayName: string = 'EndTime';

  /**
   * Render
   * @returns
   * @memberof EndTimeComponent
   */
  public render() {
    const { OnEndTimeChange, context: { end_time_name, end_time_value }, props: { required: REQUIRED }} = this;
    const required: boolean = IsFunction(REQUIRED) ? (REQUIRED as any)() : REQUIRED;
    return <CoreFormElementTime name={end_time_name} value={end_time_value} onBlur={OnEndTimeChange} required={required} className="width-17" />;
  }

  /**
   * On End Time Change
   * @protected
   * @param {FormEvent<HTMLInputElement>} { currentTarget: { validity: { valid } }}
   * @param {CoreFormValueType} value
   * @memberof EndTimeComponent
   */
  /* istanbul ignore next */
  protected OnEndTimeChange = ({ currentTarget: { validity: { valid } }}: FormEvent<HTMLInputElement>, value: CoreFormValueType): void => {
    if (valid) {
      this.context.update(undefined, undefined, undefined, value);
    }
  };
}
